import MenuButton from '../components/MenuButton'
import { RankingTable } from '../components/RankingTable'
import { useGame } from '../contexts/GameContext'
import { cn } from '../lib/utils'

export function RankingScreen() {
	const { currentScreen, changeScreen } = useGame()

	return (
		<div
			className={cn(
				'pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300',
				{
					'pointer-events-auto opacity-100': currentScreen === 'ranking',
				}
			)}
		>
			<div className="relative flex h-dvh w-full items-center justify-center overflow-hidden">
				<img src="./assets/fundo.png" alt="Fundo" className="absolute h-dvh w-dvw object-fill" />

				<MenuButton
					src="./assets/botoes/botao_fechar.svg"
					alt="Fechar"
					onClick={() => changeScreen('home')}
					title="Voltar para Home"
					className="absolute top-5 right-5 z-20 size-10"
				/>

				<RankingTable />

				<MenuButton
					src="./assets/botoes/botao_iniciar.svg"
					alt="Iniciar"
					onClick={() => changeScreen('game')}
					title="Iniciar Jogo"
					className="absolute right-[5%] bottom-[5%] z-20 h-[12%]"
				/>
			</div>
		</div>
	)
}
